import { motion } from "framer-motion";

export default function SectionHeader({ overline, title, subtitle, align = "left", testid }) {
  return (
    <div
      data-testid={testid}
      className={
        "max-w-3xl " + (align === "center" ? "mx-auto text-center" : "")
      }
    >
      {overline && (
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="overline mb-3"
        >
          {overline}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.05 }}
          className="mt-4 text-[15px] sm:text-base text-ink-200 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
